import { useMemo } from 'react'
import QRCode from 'qrcode'

export interface LoyaltyQrProps {
  /**
   * Строка, которую сканирует касса. Приходит из `GET /me/loyalty`: собирать
   * её самим нельзя — касса ждёт ровно тот формат, что задал сервер.
   */
  code: string
  /** Сторона кода в пикселях. */
  size?: number
  /** Подпись для читалки экрана — на языке интерфейса. */
  label?: string
}

/**
 * QR карты лояльности. Рисуем матрицу сами, без canvas: так код остаётся
 * чётким на любом экране, красится токеном и проверяется в тестах.
 */
export function LoyaltyQr({ code, size = 200, label }: LoyaltyQrProps) {
  const matrix = useMemo(() => {
    const { modules } = QRCode.create(code, { errorCorrectionLevel: 'M' })
    return modules
  }, [code])

  const cells: string[] = []
  for (let row = 0; row < matrix.size; row += 1) {
    for (let column = 0; column < matrix.size; column += 1) {
      if (matrix.data[row * matrix.size + column]) {
        cells.push(`M${column} ${row}h1v1h-1z`)
      }
    }
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${matrix.size} ${matrix.size}`}
      role="img"
      aria-label={label}
      shapeRendering="crispEdges"
    >
      <rect width={matrix.size} height={matrix.size} fill="#fff" />
      {/* Чёрное на белом в любой теме: сканер на кассе читает контраст, а не цвет бренда. */}
      <path d={cells.join('')} fill="#000" />
    </svg>
  )
}
